const KeyBenefits = () => {
	return (
		<section className="mx-auto flex max-w-7xl flex-wrap items-center justify-center px-6 pb-8 lg:pb-16">
			<div className="grid w-full grid-cols-2 gap-6 md:grid-cols-4">
				<div className="card-bg flex w-full flex-col rounded-2xl px-6 py-6 md:py-10">
					<div className="text-center text-2xl font-bold text-white sm:text-4xl lg:text-5xl">20x</div>
					<div className="text-center text-white sm:text-lg">Achieve 20x Faster Results than a Copywriter</div>
				</div>
				<div className="card-bg flex w-full flex-col rounded-2xl px-6 py-6 md:py-10">
					<div className="text-center text-2xl font-bold text-white sm:text-4xl lg:text-5xl">+80h</div>
					<div className="mx-auto max-w-[200px] text-center text-white sm:text-lg">
						Save Over 80 Hours of Manual Work
					</div>
				</div>
				<div className="card-bg flex w-full flex-col rounded-2xl px-6 py-6 md:py-10">
					<div className="text-center text-2xl font-bold text-white sm:text-4xl lg:text-5xl">10x</div>
					<div className="mx-auto max-w-[200px] text-center text-white sm:text-lg">More products tested everyday!</div>
				</div>
				<div className="card-bg flex w-full flex-col rounded-2xl px-6 py-6 md:py-10">
					<div className="text-center text-2xl font-bold text-white sm:text-4xl lg:text-5xl">+$500</div>
					<div className="mx-auto max-w-[200px] text-center text-white sm:text-lg">Save $500+ on Copywriting Costs</div>
				</div>
			</div>
		</section>
	);
};

export default KeyBenefits;
